import { render, staticRenderFns } from "./search.vue?vue&type=template&id=b9025b10"
import script from "./search.js?vue&type=script&lang=js&external"
export * from "./search.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports